export const OPENREPLAY_SCRIPT_ID = 'openreplay-tracker-script';

export const DEFAULT_OPENREPLAY_SCRIPT_URL = 'https://static.openreplay.com/latest/openreplay.js';

export const START_QUIZ_URL_FRAGMENT = '/test/startQuiz/';
